<template>
  <div class="profit-page">
    <h2 class="font-500 auth-page-title">{{ $t('return.title') }}</h2>
    <return-cards />
    <div class="auth-page-section">
      <b-alert show variant="info" class="mb-ten d-flex align-items-center">
        <i class="fas fa-info-circle mr-2"></i>
        <span>Зарим үнэт цаасны тооцоолол дээр систем шинэчлэлттэй холбоотой түр хугацаанд хоосон байгааг анхаарна уу</span>
      </b-alert>
      <return-table />
    </div>
  </div>
</template>

<script>
import ReturnTable from '../../components/ReturnTable'
import ReturnCards from '../../components/ReturnCards'
export default {
  components: {
    ReturnTable,
    ReturnCards,
  },
  methods: {},
  created() {
    this.$store.dispatch('fetchTotalProfits')
  }
}
</script>

<style lang="scss">
@import './ReturnPage.scss';
</style>
